module.exports = "precision mediump float;\nvarying vec4 colorForFragment;\n\nvoid main() {\n  gl_FragColor = colorForFragment;\n}\n"